"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailOrderingAppWeb = void 0;
const React = require("react");
const OrderingAppHandlerWeb_1 = require("../../../../../features/base/ordering/handlers/OrderingAppHandlerWeb");
const react_router_dom_1 = require("react-router-dom");
const AnchorScrolling_1 = require("../../../../../components/base/atoms/AnchorScrolling");
const RetailOrderingApp_1 = require("../RetailOrderingApp");
// need to separate this as when importing into the website
const RetailOrderingAppWeb = () => (React.createElement(OrderingAppHandlerWeb_1.OrderingAppHandlerWeb, { configOverride: { useRealClient: true } },
    React.createElement(react_router_dom_1.BrowserRouter, null,
        React.createElement(AnchorScrolling_1.AnchorScrolling, null),
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { path: "/", component: RetailOrderingApp_1.RetailOrderingApp })))));
exports.RetailOrderingAppWeb = RetailOrderingAppWeb;
//# sourceMappingURL=index.js.map